module.exports = __webpack_public_path__ + "img/icon-folder.2a284224.svg";